import createEnum from 'scripts/lib/create_enum';

const AttachmentSourceType = createEnum('SNIPPET', 'UPLOAD');

export default AttachmentSourceType;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/attachment/attachment_source_type.js